import { Field, useFormikContext } from "formik";
import React, { Suspense } from "react";
import style from "./Paragraph.module.scss";
import { ReactQuillWrapper } from "../ReactQuillWrapper";
import {
  Button,
  Checkbox,
  Group,
  NativeSelect,
  Stack,
  TextInput,
  Title,
} from "@mantine/core";
import type { FieldProps } from "formik";

type Props = {
  index: number;
  onRemove(): void;
};

const HEADINGS = [
  { value: "h2", label: "h2" },
  { value: "h3", label: "h3" },
  { value: "h4", label: "h4" },
  { value: "h5", label: "h5" },
  { value: "h6", label: "h6" },
];

const Paragraph: React.FC<Props> = ({ index, onRemove }) => {
  const { setFieldValue, values } = useFormikContext();
  const paragraphs = (values as { paragraphs: { h?: string; text: string }[] })
    .paragraphs;
  return (
    <Stack gap="md" className={style.container}>
      <Title order={4}>Paragraf</Title>
      <Field name={`paragraphs.${index}.title`}>
        {({ field, meta }: FieldProps) => (
          <TextInput
            label="Tytuł"
            {...field}
            value={field.value ?? ""}
            error={meta.touched ? meta.error : undefined}
          />
        )}
      </Field>
      <NativeSelect
        label="Poziom nagłówka"
        data={HEADINGS}
        value={paragraphs[index]?.h || "h2"}
        onChange={(e) =>
          setFieldValue(`paragraphs.${index}.h`, e.currentTarget.value)
        }
      />
      <div className={style.text}>
        <div>Tekst</div>
        <Suspense fallback={<div>Ładowanie</div>}>
          <ReactQuillWrapper
            value={paragraphs[index]?.text ?? ""}
            onChange={(value) => {
              setFieldValue(`paragraphs.${index}.text`, value);
            }}
          />
        </Suspense>
      </div>
      <Field name={`paragraphs.${index}.quote`}>
        {({ field, meta }: FieldProps) => (
          <TextInput
            label="Cytat"
            {...field}
            value={field.value ?? ""}
            error={meta.touched ? meta.error : undefined}
          />
        )}
      </Field>

      <Field name={`paragraphs.${index}.fade`}>
        {({ field, form }: FieldProps) => (
          <Checkbox
            label="Rozwijany"
            checked={field.value}
            onChange={(e) =>
              form.setFieldValue(field.name, e.currentTarget.checked)
            }
          />
        )}
      </Field>
      <Field name={`paragraphs.${index}.defaultFaded`}>
        {({ field, form }: FieldProps) => (
          <Checkbox
            label="Domyślnie zwinięty"
            checked={field.value}
            onChange={(e) =>
              form.setFieldValue(field.name, e.currentTarget.checked)
            }
          />
        )}
      </Field>
      <Field name={`paragraphs.${index}.order`}>
        {({ field, meta }: FieldProps) => (
          <TextInput
            label="Kolejność"
            {...field}
            value={
              field.value == null || field.value === ""
                ? ""
                : String(field.value)
            }
            error={meta.touched ? meta.error : undefined}
          />
        )}
      </Field>
      <Group justify="flex-end" mt="xs">
        <Button
          type="button"
          variant="light"
          color="red"
          size="sm"
          radius="md"
          onClick={onRemove}
        >
          Usuń paragraf
        </Button>
      </Group>
    </Stack>
  );
};

export default Paragraph;
